






























import Vue, { PropType } from "vue";

interface JoinConfirmFormProps {
  lang: any;
  joinUrl: string;
  startUrl: string;
  userName: string;
  identifier: string;
  csrfToken: string;
}

interface JoinConfirmFormData {
  isLoading: boolean;
}

export default Vue.extend({
  name: "vc-join-confirm-form",
  props: {
    lang: {
      type: Object as PropType<JoinConfirmFormProps["lang"]>,
      default: () => {},
    },
    joinUrl: {
      type: String as PropType<JoinConfirmFormProps["joinUrl"]>,
      default: "",
    },
    startUrl: {
      type: String as PropType<JoinConfirmFormProps["startUrl"]>,
      default: "",
    },
    userName: {
      type: String as PropType<JoinConfirmFormProps["userName"]>,
      default: "",
    },
    identifier: {
      type: String as PropType<JoinConfirmFormProps["identifier"]>,
      default: "",
    },
    csrfToken: {
      type: String as PropType<JoinConfirmFormProps["csrfToken"]>,
      default: "",
    },
  },
  data(): JoinConfirmFormData {
    return {
      isLoading: false,
    };
  },
  computed: {},
  methods: {},
});
